export const API_URL = 'https://forkify-api.herokuapp.com/api/v2/recipes/';
export const TIMEOUT_SEC = 10;
export const RES_PER_PAGE = 10;
export const KEY = '8e520054-b206-4fa1-b8b0-a371d33677ff';
export const MODEL_CLOSE_SEC = 2.5;
